import React from 'react';
import {BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Inicio from './pages/Inicio/Inicio';
import Portafolio from './pages/portafolio/Portafolio';
import Blog from './pages/Blog/Blog';

function App() {
  return (
    <Router>
      <div className="container-fluid p-0 main-inicio">
        <Navbar />
        
        <Switch>
            <Route path="/" exact>
              <Inicio />
            </Route>
            <Route path="/contacto">
              Login...
            </Route>
            <Route path="/portafolio">
              <Portafolio />
            </Route>
            <Route path="/blog">
              <Blog />
            </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
